import { Grid2 } from "@mui/material";
import PlanGraphStyle from "./PlanGraphStyle.module.scss";
import { ReactComponent as SiteIcon } from "../../../../AdminAssets/svg/Site_plan.svg";
import { ReactComponent as StorageIcon } from "../../../../AdminAssets/svg/Storage_plan.svg";
import { ReactComponent as PlanIcon } from "../../../../AdminAssets/svg/Exp_plan.svg";
import { ReactComponent as VisitsIcon } from "../../../../AdminAssets/svg/VisitsIcon.svg";
import InfoRow from "../InfoRow/InfoRow";
import CirclePlanGraph from "../../../../AdminComponents/CirclePlanGraph/CirclePlanGraph";
import { useSelector } from "react-redux";
import { differenceInDays } from "date-fns";
import { formatFileSizeCaps } from "../../../../../../Utils/roconConstants";

function PlanGraph(props) {
  const { specificPlan } = props;

  const plan = useSelector(
    (state) => state.plansInfo?.specificPlan?.specificPlans
  );

  let sitesUsed = "N/A";
  let sitesLimit = "N/A";
  let storageUsed = "N/A";
  let storageLimit = "N/A";
  let visitsUsed = "N/A";
  let visitsLimit = "N/A";

  if (plan?.length > 0) {
    const featureDetails = plan[0].featureDetails;
    featureDetails.forEach((feature) => {
      switch (feature.type) {
        case "NUM_SITES":
          sitesUsed =
            feature.used === null || parseInt(feature.used) === 0
              ? 0
              : feature.used;
          sitesLimit = feature?.limitOrAvailablity;
          break;
        case "STORAGE":
          storageUsed = parseInt(feature?.used);
          storageLimit = feature.limitOrAvailablity + " GB";
          break;
        case "VISITS":
          visitsUsed = feature?.used;
          visitsLimit = feature?.limitOrAvailablity;
          break;
        default:
          break;
      }
    });
  }

  const startTimestamp = plan?.length > 0 ? plan[0].creationDate : null;
  const endTimestamp = plan?.length > 0 ? plan[0].expirationDate : null;

  const millisecondsInADay = 1000 * 60 * 60 * 24;

  const totalDays =
    Math.ceil((endTimestamp - startTimestamp) / millisecondsInADay) + " Days";

  function convertTimestampAndCalculateDays(startTimestamp) {
    const startDate = new Date(startTimestamp);
    const currentDate = new Date(Date.now());

    const formattedStartDate = startDate.toISOString().split("T")[0];
    const formattedCurrentDate = currentDate.toISOString().split("T")[0];

    const difference = differenceInDays(
      formattedCurrentDate,
      formattedStartDate
    );

    return difference;
  }

  const convertedStorageUsed = formatFileSizeCaps(storageUsed);

  return (
    <Grid2 className={PlanGraphStyle.FlexBox}>
      <Grid2 className={PlanGraphStyle.licenseChart}>
        <CirclePlanGraph specificPlan={specificPlan} />
      </Grid2>
      <Grid2>
        <InfoRow
          Icon={SiteIcon}
          label="Total No. Sites"
          used={sitesUsed}
          total={sitesLimit}
          iconClass={PlanGraphStyle.icon}
        />
        <InfoRow
          Icon={StorageIcon}
          label="Total Storage"
          used={convertedStorageUsed}
          total={storageLimit}
          iconClass={PlanGraphStyle.icon2}
        />
        <InfoRow
          Icon={VisitsIcon}
          label="Total Visits"
          used={visitsUsed}
          total={visitsLimit}
          iconClass={PlanGraphStyle.icon3}
        />
        <InfoRow
          Icon={PlanIcon}
          label="Plan Expire"
          used={convertTimestampAndCalculateDays(startTimestamp)}
          total={totalDays}
          iconClass={PlanGraphStyle.icon3}
        />
      </Grid2>
    </Grid2>
  );
}

export default PlanGraph;
